import { theme } from '../../theme/theme';
import { CopyButton } from './CopyButton';
import { LabelValue } from './LabelValue';

type ModulIdLabelValueProps = {
  readonly akaModulId: string;
};

export const ModulIdLabelValue = ({ akaModulId }: ModulIdLabelValueProps) => (
  <div className="flex">
    <LabelValue color="brand" label="AKA-Modul-ID" value={akaModulId} />
    <CopyButton
      text={akaModulId.slice(0, 6)}
      buttonStyles={{ color: theme.palette.text.primaryOnBrand, height: '1rem' }}
    />
  </div>
);
